// extracted by mini-css-extract-plugin
export var container = "styles-module--container--O47OY";
export var desktop = "1340px";
export var giant = "2200px";
export var grid = "styles-module--grid--kKUxv";
export var gridItem = "styles-module--gridItem--s4AkI";
export var gridItemBackground = "styles-module--gridItemBackground--GMse9";
export var gridItemContent = "styles-module--gridItemContent--Jn6B-";
export var gridItemDisabled = "styles-module--gridItemDisabled--5xa7I";
export var gridItemL = "styles-module--gridItemL--Dm9Er";
export var gridItemM = "styles-module--gridItemM--3hfMZ";
export var gridItemS = "styles-module--gridItemS--zIsbj";
export var gridItemSubtitle = "styles-module--gridItemSubtitle--tk19n";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";